import React, { Fragment } from 'react';
import { isNil } from 'lodash';
import Anchor from '../../../../components/link/Anchor';
import { setCopyToClipboardIcon } from '../../../../lib/utils/commonUtils';

const SendMessageService = (props) => {
  const { text, memberType, targetId, prepareSendMessageService } = props;

  /**
   * 링크로 연결할 데이터가 없다면
   * '-' 를 반환함
   */
  if (isNil(text) || !prepareSendMessageService) {
    return '-';
  }

  return (
    <Fragment>
      <Anchor
        color="primary"
        isUnderLine
        text={text}
        onClick={() =>
          prepareSendMessageService({
            memberType,
            targetId,
            cellPhone: text,
          })
        }
      />
      {setCopyToClipboardIcon(text)}
    </Fragment>
  );
};

export default SendMessageService;
